import { render } from "./index.vue?vue&type=template&id=3a44ef0c"
import script from "./hamburger.ts?vue&type=script&lang=js"
export * from "./hamburger.ts?vue&type=script&lang=js"

import "./hamburger.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script